import { render, staticRenderFns } from "./FormSupplier.vue?vue&type=template&id=2c7f1a5c&scoped=true"
import script from "./FormSupplier.vue?vue&type=script&lang=js"
export * from "./FormSupplier.vue?vue&type=script&lang=js"
import style0 from "./FormSupplier.vue?vue&type=style&index=0&id=2c7f1a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7f1a5c",
  null
  
)

export default component.exports